Cookiebar = {

    view: function(){
        
        if(Cookies.get('closedEuCookieBar'))
            return;

        var bar =  $('div.euCookies');
        var okButton = $(bar).find('a.button');
        console.log(okButton);
        okButton.on('click', Cookiebar.close);
        
        bar.css({display: 'block', opacity: 0 });
        var height = bar.height();

        bar.height(0)
        setTimeout(function(){bar.css({opacity: 1}) })

        bar.stop().delay(1000).animate({height: height}, 500, function(){
            $(this).css({height: ''});
        });
    },
    
    close: function(){

        console.log('close');
         
        $('div.euCookies').stop().delay(100).animate({height:0},500, function(){
            $(this).remove(); 
        })
         
        Cookies.set('closedEuCookieBar', 1, {expires: 365});
        Header.resize();
    }
}